/**
 * 色定数
 */
export const ColorPalettes = {
  /**
   * 白
   */
  GRAY: '#4A4A4A',
  /**
   * 白
   */
  WHITE: '#ffffff',
  /**
   * メインカラー（ヘッダやボタンなど）
   */
  MAIN: '#3582BC',
  /**
   * LINEメインカラー
   */
  LINE_MAIN: '#06c755'
} as const satisfies Record<string, string>;
